var React = require('react');

function MenuButtonBackground (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Rectangle"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"menubuttonbackground_DESKTOP","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"menubuttonbackground_BLASTGALAXY-","transform":"translate(-1437.000000, -1230.000000)","fill":"#000000","stroke":"#FFFFFF","strokeWidth":"5.2"},React.createElement("g",{"id":"menubuttonbackground_Nav-bar","transform":"translate(87.000000, 1217.000000)"},React.createElement("path",{"d":"M1374.79556,15.6 L1353.48385,87.4 L1652.4,87.4 L1652.4,15.6 L1374.79556,15.6 Z","id":"menubuttonbackground_Rectangle"}))))]);
}

MenuButtonBackground.defaultProps = {"preserveAspectRatio":"none","viewBox":"0 0 305 77","version":"1.1"};

module.exports = MenuButtonBackground;

MenuButtonBackground.default = MenuButtonBackground;
